/**
 * Адаптер преобразует текст в текст для html-полей.
 * @type {{toBrokenText(*): string}}
 */
const TextAdapter = {
  /**
   * Преобразует текстовые переносы строк в HTML-теги <br/>.
   * Заменяет различные форматы переносов строк (\r\n, \r, \n) на HTML-эквивалент.
   * Полезно для отображения многострочного текста в HTML-контенте.
   *
   * @param {string} text - Исходный текст с переносами строк
   * @returns {string} Текст с замененными переносами на <br/>
   *                  или пустая строка, если входные данные невалидны
   */
  toBrokenText(text) {
    return text && text.length ? text.replace(/(\r\n|\r|\n)/g, '<br/>') : '';
  },
  /**
   * Форматирует числовую строку или число в финансовый формат с разделителями тысяч.
   * Добавляет пробелы между группами из трех цифр для лучшей читаемости.
   * Поддерживает как строковые, так и числовые входные данные.
   *
   * @example
   * toFinancial('1234567'); // returns '1 234 567'
   * toFinancial(1000);    // returns '1 000'
   *
   * @param {string|number} value - Число или числовая строка для форматирования
   * @returns {string} Отформатированная строка с разделителями тысяч
   *                  или пустая строка, если входные данные невалидны
   */
  toFinancial(value) {
    if (value === null || value === undefined) return '';

    const textStr = typeof value === 'number' ? value.toString() : value;
    return textStr.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  },

  /**
   * Преобразует финансовый формат обратно в чистую числовую строку.
   * Удаляет все пробелы и символы валюты для получения исходного числа.
   *
   * @example
   * fromFinancial('1 234 567'); // returns '1234567'
   * fromFinancial('$1 000');    // returns '1000'
   * fromFinancial('1 000 руб.'); // returns '1000'
   *
   * @param {string} text - Строка в финансовом формате (может содержать пробелы, символы валюты)
   * @returns {string} Чистая числовая строка без форматирования
   *                  или пустая строка, если входные данные невалидны
   */
  fromFinancial(text) {
    return text && text.length ? text.replace(/\$\s?|(\s*)/g, '') : '';
  },
};

export { TextAdapter };
